const RANKING_ITEMS = [
  { id: 1, rank: 1, name: '瓜田日报', category: '综合爆料', score: '9.8', trend: 'up', desc: '更新最勤快的吃瓜爆料网站，每日推送多条独家爆料，内容覆盖娱乐圈、网红圈和社会热点。' },
  { id: 2, rank: 2, name: '八卦档案馆', category: '历史爆料', score: '9.6', trend: 'up', desc: '最全的娱乐圈历史爆料资料库，各类明星黑历史、旧瓜整理得井井有条，吃瓜考古首选。' },
  { id: 3, rank: 3, name: '热点追踪器', category: '实时爆料', score: '9.5', trend: 'same', desc: '专注实时热点事件追踪，爆料速度快，信息更新及时，适合关注最新动态的吃瓜群众。' },
  { id: 4, rank: 4, name: '网红扒皮站', category: '网红爆料', score: '9.3', trend: 'down', desc: '网红圈专属爆料平台，从头部主播到腰部博主全覆盖，内容真实度较高。' },
  { id: 5, rank: 5, name: '综艺剧透王', category: '综艺爆料', score: '9.1', trend: 'up', desc: '综艺节目录制内幕和提前剧透的专业平台，选秀淘汰名单准确率高。' },
  { id: 6, rank: 6, name: '海外吃瓜局', category: '海外八卦', score: '8.9', trend: 'up', desc: '日韩欧美娱乐圈一手资讯翻译汇总，让你不错过国际娱乐圈的最新爆料。' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3">
            热门榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜爆料网站人气排行
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
            根据活跃度、内容质量和用户反馈综合评定的吃瓜爆料网站排名
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
            {RANKING_ITEMS.map((item, idx) => (
              <div
                key={item.id}
                className={`flex items-start gap-4 p-4 md:p-5 ${
                  idx < RANKING_ITEMS.length - 1 ? 'border-b border-background-200/60' : ''
                } hover:bg-primary-50/30 transition-colors cursor-pointer`}
              >
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 font-heading font-bold text-sm ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-primary-400 text-background-50' :
                  item.rank === 3 ? 'bg-accent-500 text-background-50' :
                  'bg-secondary-200 text-foreground-700'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950">
                      {item.name}
                    </h3>
                    <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.category}
                    </span>
                    {item.trend === 'up' && (
                      <span className="text-xs text-green-600 whitespace-nowrap">
                        <i className="ri-arrow-up-line"></i>
                      </span>
                    )}
                    {item.trend === 'down' && (
                      <span className="text-xs text-red-500 whitespace-nowrap">
                        <i className="ri-arrow-down-line"></i>
                      </span>
                    )}
                    {item.trend === 'same' && (
                      <span className="text-xs text-foreground-400 whitespace-nowrap">
                        <i className="ri-subtract-line"></i>
                      </span>
                    )}
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
                <div className="shrink-0 text-right">
                  <div className="text-lg font-heading font-bold text-primary-600">{item.score}</div>
                  <div className="text-[10px] text-foreground-500">综合评分</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}